import { render } from "./AttentionIcon.vue?vue&type=template&id=39c20bfa&scoped=true"
import script from "./AttentionIcon.vue?vue&type=script&lang=js"
export * from "./AttentionIcon.vue?vue&type=script&lang=js"

import "./AttentionIcon.vue?vue&type=style&index=0&id=39c20bfa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c20bfa"]])

export default __exports__